export default __webpack_public_path__ + "static/media/testi2.3f13083a.png";